class DevFaq extends HTMLElement {
  connectedCallback() {
    this.bindItems();
  }

  bindItems() {
    this.items = Array.from(this.querySelectorAll('.dev-faq__item'));

    this.items.forEach((details) => {
      const summary = details.querySelector('summary');
      const wrap = details.querySelector('.dev-faq__answer-wrap');
      if (!summary || !wrap) return;

      /* Items open on load keep their natural height. */
      if (details.open) {
        wrap.style.height = 'auto';
      }

      summary.addEventListener('click', (e) => {
        e.preventDefault();

        if (details.open) {
          this.collapse(details);
        } else {
          /* Single-open accordion: always close whichever item was previously open. */
          this.items.forEach((other) => {
            if (other !== details && other.open) this.collapse(other);
          });
          this.expand(details);
        }
      });
    });
  }

  /* Collapse: pin the current height, then animate to 0. */
  collapse(details) {
    const wrap = details.querySelector('.dev-faq__answer-wrap');
    if (!wrap) return;
    wrap.style.height = wrap.scrollHeight + 'px';
    wrap.offsetHeight; /* force reflow so the pixel value registers */
    requestAnimationFrame(() => {
      wrap.style.height = '0px';
    });
    wrap.addEventListener('transitionend', () => {
      details.open = false;
    }, { once: true });
  }

  /* Expand: reveal, then animate from 0 to the measured height. */
  expand(details) {
    const wrap = details.querySelector('.dev-faq__answer-wrap');
    if (!wrap) return;
    details.open = true;
    const target = wrap.scrollHeight;
    wrap.style.height = '0px';
    requestAnimationFrame(() => {
      wrap.style.height = target + 'px';
    });
    wrap.addEventListener('transitionend', () => {
      wrap.style.height = 'auto';
    }, { once: true });
  }
}

customElements.define('dev-faq', DevFaq);
